
interface WithDisplayLevel {
  display_level: number
}

export const sortByDisplayLevel = {
  asc: defineSortLogic((a: WithDisplayLevel, b: WithDisplayLevel) => {
    if (a.display_level < b.display_level) return -1
    if (a.display_level > b.display_level) return 1

    return 0
  }),
} as const

function defineSortLogic(compare: (a: WithDisplayLevel, b: WithDisplayLevel) => number): SortLogic {
  const sort = <T extends WithDisplayLevel>(items: T[]): T[] => [...items].sort(compare)

  return { compare, sort }
}
interface SortLogic {
  compare<T extends WithDisplayLevel>(a: T, b: T): number
  sort<T extends WithDisplayLevel>(items: T[]): T[]
}
